export { getAssignmentHistoryErrorFilterOptions as personAssignmentHistoryErrorFilterOptions } from '../../departmentAssignmentHistory/config/getAssignmentHistoryErrorFilterOptions';
